"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlHero = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable @typescript-eslint/ban-types */
var theme_1 = require("../theme");
var GlImage_1 = require("../utils/GlImage");
var react_1 = require("react");
var theme_2 = require("../theme");
var onyxia_ui_1 = require("onyxia-ui");
var framer_motion_1 = require("framer-motion");
var theme_3 = require("../theme");
var GlArrow_1 = require("../utils/GlArrow");
var useConstCallback_1 = require("powerhooks/useConstCallback");
var getScrollableParent_1 = require("powerhooks/getScrollableParent");
var GlHeroText_1 = require("./GlHeroText");
var GlVideo_1 = require("../utils/GlVideo");
var useStateRef_1 = require("powerhooks/useStateRef");
var illustrationId = "illustrationId";
var textWrapperVariant = {
    "show": {},
    "hidden": { "opacity": 0 },
};
var textVariant = {
    "show": {},
    "hidden": {
        "x": -150,
        "opacity": 0,
    },
};
var imageAnimProps = {
    "transition": {
        "delay": 1,
        "duration": 0.5,
    },
    "initial": {
        "opacity": 0,
    },
    "animate": {},
};
exports.GlHero = (0, react_1.memo)(function (props) {
    var title = props.title, subTitle = props.subTitle, className = props.className, hasLinkToSectionBellow = props.hasLinkToSectionBellow, illustration = props.illustration, hasAnimation = props.hasAnimation;
    var _a = __read((0, react_1.useState)(false), 2), isAnimationComplete = _a[0], setIsAnimationComplete = _a[1];
    var _b = __read((0, react_1.useState)(false), 2), isImageLoaded = _b[0], setIsImageLoaded = _b[1];
    var ref = (0, useStateRef_1.useStateRef)(null);
    var handleOnIllustrationLoad = (0, useConstCallback_1.useConstCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 50); })];
                case 1:
                    _a.sent();
                    setIsImageLoaded(true);
                    return [2 /*return*/];
            }
        });
    }); });
    var animate = (0, useConstCallback_1.useConstCallback)(function () {
        textWrapperVariant.show = {
            "transition": {
                "staggerChildren": 0.5,
            },
            "opacity": 1,
        };
        textVariant.show = {
            "opacity": 1,
            "x": 0,
            "transition": {
                "duration": 1,
                "ease": "easeOut",
            },
        };
        imageAnimProps.animate = {
            "opacity": 1,
        };
        setIsAnimationComplete(true);
    });
    (0, onyxia_ui_1.useSplashScreen)({
        "onHidden": function () {
            if (isImageLoaded &&
                isAnimationComplete &&
                (hasAnimation || hasAnimation === undefined)) {
                animate();
            }
        },
    });
    (0, react_1.useEffect)(function () {
        if (!isImageLoaded ||
            isAnimationComplete ||
            (!hasAnimation && hasAnimation !== undefined)) {
            return;
        }
        animate();
    }, [isImageLoaded]);
    var onClick = (0, useConstCallback_1.useConstCallback)(function () {
        var element = ref.current;
        if (!element)
            return;
        (0, getScrollableParent_1.getScrollableParent)({
            element: element,
            "doReturnElementIfScrollable": true,
        }).scrollTo({
            "behavior": "smooth",
            "top": element.clientHeight,
        });
    });
    var _c = useStyles({
        "hasOnlyText": illustration === undefined,
        isImageLoaded: isImageLoaded,
    }, { props: props }), classes = _c.classes, cx = _c.cx;
    return ((0, jsx_runtime_1.jsxs)("section", __assign({ ref: ref, className: cx(classes.root, className) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.textAndImageWrapper }, { children: [(title !== undefined || subTitle !== undefined) && ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, __assign({ className: classes.textWrapper }, (function () {
                        if (!hasAnimation && hasAnimation !== undefined) {
                            return;
                        }
                        return {
                            "variants": textWrapperVariant,
                            "initial": "hidden",
                            "animate": "show",
                        };
                    })(), { children: [title !== undefined && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, __assign({ variants: hasAnimation || hasAnimation === undefined
                                    ? textVariant
                                    : undefined }, { children: typeof title === "string" ? ((0, jsx_runtime_1.jsx)(GlHeroText_1.GlHeroText, __assign({ className: classes.title }, { children: title }))) : (title) }))), subTitle !== undefined && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, __assign({ variants: hasAnimation || hasAnimation === undefined
                                    ? textVariant
                                    : undefined }, { children: typeof subTitle === "string" ? ((0, jsx_runtime_1.jsx)(theme_1.Text, __assign({ typo: "subtitle", className: classes.subtitle }, { children: subTitle }))) : (subTitle) })))] }))), illustration !== undefined && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, __assign({}, (hasAnimation || hasAnimation === undefined
                        ? imageAnimProps
                        : undefined), { className: classes.imageWrapper }, { children: (function () {
                            switch (illustration.type) {
                                case "image":
                                    return ((0, jsx_runtime_1.jsx)(GlImage_1.GlImage, __assign({ id: illustrationId, className: classes.illustration, alt: "hero image", onLoad: handleOnIllustrationLoad }, illustration)));
                                case "video":
                                    return ((0, jsx_runtime_1.jsx)(GlVideo_1.GlVideo, __assign({ id: illustrationId, className: classes.illustration, onLoad: handleOnIllustrationLoad }, illustration)));
                                case "custom component":
                                    return ((0, jsx_runtime_1.jsx)(illustration.Component, { id: illustrationId, className: classes.illustration, onLoad: handleOnIllustrationLoad }));
                            }
                        })() })))] })), hasLinkToSectionBellow !== undefined && ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.linkToSectionBelowWrapper }, { children: (0, jsx_runtime_1.jsx)(GlArrow_1.GlArrow, { onClick: onClick, className: classes.arrow, direction: "down", hasCircularBorder: true }) })))] })));
});
var useStyles = (0, theme_2.makeStyles)({ "name": { GlHero: exports.GlHero } })(function (theme, _a) {
    var hasOnlyText = _a.hasOnlyText, isImageLoaded = _a.isImageLoaded;
    return ({
        "root": __assign({ "width": "100%", "paddingBottom": theme.spacing(7) }, theme.spacing.rightLeft("padding", "".concat(theme.paddingRightLeft, "px"))),
        "arrow": {
            "cursor": "pointer",
        },
        "textAndImageWrapper": __assign({ "margin": theme.spacing({
                "topBottom": 5,
                "rightLeft": 0,
            }), "minHeight": (window.innerHeight / 100) * 70, "display": "flex", "alignItems": "center", "justifyContent": "center" }, (theme.windowInnerWidth < theme_3.breakpointsValues.md
            ? {
                "flexDirection": "column",
                "alignItems": "left",
            }
            : {})),
        "title": {
            "marginBottom": theme.spacing(4),
        },
        "subtitle": __assign({ "marginTop": theme.spacing(4), "maxWidth": 650, "color": theme.colors.useCases.typography.textSecondary }, (function () {
            if (theme.windowInnerWidth >= theme_3.breakpointsValues["lg+"]) {
                return undefined;
            }
            return theme.typography.variants["body 1"].style;
        })()),
        "textWrapper": __assign(__assign(__assign({ "textAlign": hasOnlyText && theme.windowInnerWidth >= theme_3.breakpointsValues.sm
                ? "center"
                : undefined, "alignItems": hasOnlyText ? "center" : undefined, "flexDirection": "column" }, (function () {
            if (theme.windowInnerWidth < theme_3.breakpointsValues.md) {
                return undefined;
            }
            return {
                "maxWidth": 800,
                "minWidth": 400,
            };
        })()), { "display": "flex" }), (function () {
            var value = theme.spacing(7);
            if (theme.windowInnerWidth >= theme_3.breakpointsValues.md) {
                return {
                    "marginRight": hasOnlyText ? undefined : value,
                };
            }
            return {
                "marginBottom": value,
            };
        })()),
        "imageWrapper": {},
        "illustration": {
            "display": "inline-block",
            "width": "100%",
        },
        "linkToSectionBelowWrapper": {
            "display": "flex",
            "justifyContent": "center",
            "transition": "opacity 300ms",
            "opacity": isImageLoaded ? 1 : 0,
        },
    });
});
//# sourceMappingURL=GlHero.js.map